//loans
export const MIN_LOAN = 500;
export const MAX_LOAN = 15000;
export const START_SUMM = 2000;
export const LOAN_STEP = 100;

//days
export const MIN_DAYS = 5;
export const MAX_DAYS = 30;
export const DAYS_STEP = 1;
